import { useState } from "react";
import { homeFAQ } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium tracking-wide uppercase mb-3">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            Everything you need to know about Superbuy spreadsheets and how they work.
          </p>
        </div>

        <div className="space-y-3">
          {homeFAQ.map((item, index) => (
            <div
              key={index}
              className="rounded-xl bg-white border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 shrink-0 transition-transform duration-200 ${openIndex === index ? "rotate-45" : ""}`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}